import { Component, OnInit } from '@angular/core';
import { RecordService } from 'app/main/services/record.service';
import { DatasetActionContainerService } from 'app/main/services/datasetACS';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TourService } from 'app/main/services/tour.service';
import { AppService } from 'app/main/services/app.service';
import { TranslateService } from '@ngx-translate/core';
import { BasePageDirective } from '../base-page';

@Component({
	selector: 'app-detail',
	templateUrl: './detail.component.html',
	styleUrls: ['./detail.component.scss']
})
export class DetailPageComponent extends BasePageDirective implements OnInit{

	_response: any;

	constructor(
		public recordService: RecordService, 
		public datasetACS: DatasetActionContainerService,
		public tourService: TourService,
		public appService: AppService,
		protected activatedRoute: ActivatedRoute,
		protected router: Router,
		protected translate: TranslateService) {
		// init super constructor
		super(activatedRoute, router, appService, datasetACS, recordService, translate);
		/**
		 * init dataset
		 */
		this.datasetACS.init({datasetCode: this.activatedRoute.snapshot.params['datasetCode']});
	}

	ngOnInit(): void {
		this.appService.loadingLanguages.next(true);
		/**
		 * before load reset data
		 */
		this.tourService.initForm();
		this.recordService.setExtraParams({adults: 1, children: 0, infants: 0, seniors: 0});
		// if route lang
		if (this.route.snapshot.paramMap.get('lang')){
			this.recordService.extraParams['lang'] = this.route.snapshot.paramMap.get('lang');
		}

		/**
		 * parent ngOnInit
		 */
		super.ngOnInit();
	}

	protected load(): Observable<any>{
		return this.recordService.reload();
	}

	protected onLoaded(response, switched?: boolean): void{
		/** response */
		this._response = response;
		/** set some tour service properties */
		this.tourService.is_first_loading = response.is_first_loading;
		this.tourService.show_booking_form = response.show_booking_form;
	}
}
